// AutoMapper
import "reflect-metadata";
import {
    AutoMapper,
    ProfileBase,
    mapFrom,
    Mapper,
    convertUsing,
    Converter
} from "@nartc/automapper";

// Models
import { CountryDto } from 'app/_mapper/country.dto';
import { CountryVm } from 'app/_mapper/country.vm';

export class CountryProfile extends ProfileBase {
    constructor(mapper: AutoMapper) {
        super();

        mapper
            .createMap(CountryDto, CountryVm);
            
        mapper
            .createMap(CountryVm, CountryDto);
    }
}
